var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWheelCenterContainer = function SvgWheelCenterContainer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 59 59"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WheelCenterContainer_svg__a)",
    d: "M49.903 50.127c11.323-11.324 11.323-29.683 0-41.006S20.22-2.202 8.897 9.12c-11.323 11.323-11.323 29.682 0 41.006 11.324 11.323 29.682 11.323 41.006 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.903 50.127c11.323-11.324 11.323-29.683 0-41.006S20.22-2.202 8.897 9.12c-11.323 11.323-11.323 29.682 0 41.006 11.324 11.323 29.682 11.323 41.006 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#WheelCenterContainer_svg__b)",
    d: "M49.27 46.449c9.274-10.963 7.905-27.37-3.058-36.643C35.249.53 18.842 1.9 9.569 12.864.294 23.827 1.663 40.233 12.627 49.507s27.369 7.905 36.643-3.058"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "WheelCenterContainer_svg__a",
    x1: 10.605,
    x2: 54.573,
    y1: 10.817,
    y2: 54.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FDC347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FC8682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FA2CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#987CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33D0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "WheelCenterContainer_svg__b",
    x1: 50.993,
    x2: -1.447,
    y1: 8.083,
    y2: 60.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000604"
  })))));
};
export default SvgWheelCenterContainer;